import { css } from "@emotion/css";
import useTheme from "@common/hooks/useTheme";

const useStyles = () => {
  const theme = useTheme();

  const page = css`
    padding: 0;
  `;

  const card = css`
    border-radius: 4px;
    border: 1px solid ${theme.colors.gray["2"]};
    background: ${theme.colors.white};
  `;

  const cardHeader = css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.navy["1"]};
    padding: 0px 16px;
  `;

  const headerRow = css`
    padding: 20px 0 0 20px;
    align-items: center;
  `;

  const title = css`
    font-family: "Open Sans", sans-serif;
    font-size: 24px;
    font-weight: 700;
    color: ${theme.colors.navy["1"]};
  `;

  const hr = css`
    margin-left: 30px;
    margin-right: 30px;
  `;

  const formLabel = css`
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: ${theme.colors.navy["1"]};
    margin-bottom: 4px;
  `;

  const deleteButton = css`
    cursor: pointer;
    color: ${theme.colors.gray["4"]};
    &:hover {
      color: ${theme.colors.red};
    }
  `;

  const editLink = css`
    color: ${theme.colors.teal["1"]};
    text-decoration: underline;
    cursor: pointer;
    font-weight: 600;
  `;

  return {
    page,
    card,
    cardHeader,
    headerRow,
    title,
    hr,
    formLabel,
    editLink,
  };
};

export default useStyles;
